var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsLogoNaverWh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 21,
    viewBox: "0 0 58 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_1225)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2436 5L12.9434 16H16.5793L17.1032 14.534H21.2552L21.7791 16H25.415L21.1148 5H17.2456H17.2436ZM19.1792 8.53111L20.405 11.967H17.9534L19.1792 8.53111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1611 5V16H45.7478V13.2505H40.633V11.7825H45.5659V9.21749H40.633V7.7495H45.7478V5H37.1611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3447 5L29.7666 12.2328L27.1864 5H23.5327L27.831 16H31.7002L36.0004 5H32.3447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2911 5V10.8878L4.29337 5H0.799805V16H4.27162V10.1122L8.26936 16H11.7629V13.9051V5H8.2911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7978 10.134H50.8641V7.75146H52.7879C53.3 7.75146 53.7745 8.07084 53.9267 8.56282C54.1817 9.38211 53.5767 10.1359 52.7978 10.1359V10.134ZM55.2296 12.2268L55.5618 12.088C56.835 11.5524 57.4835 10.3958 57.4835 8.92585C57.4835 7.53721 56.9794 6.50763 55.9829 5.87084C55.0576 5.2777 53.8555 5.00195 52.2026 5.00195H47.5742V16.002H51.046V12.8855H52.2936L54.4091 16.002H57.9996L55.2276 12.2288L55.2296 12.2268Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_1225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.2,
    height: 11,
    fill: "white",
    transform: "translate(0.799805 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsLogoNaverWh);
export default __webpack_public_path__ + "static/media/BS_logo_naver_wh.62ca512fe4863dcade34a09f1e52ce1d.svg";
export { ForwardRef as ReactComponent };